

import { configureStore } from "@reduxjs/toolkit";
import navigationReducer from "../features/navigation/navigationSlice";
import carouselReducer from "../features/images/imageSlice";
import { newsSlice } from "../features/news/NewLayoutSlice";
import userReducer from "../features/admin/UserSlice";
import categorySlice from "../features/news/CategorySlice";
import youtubeSlice from "../features/news/YoutubePostsSlice";
import socialresponsibilitySlice from "../features/news/SocialResponsibilitySlice";
import newSliceOtherSlice from "../features/news/NewsSliceOther";
import logoSlice from "../features/news/LogoSlice";
import postsSlice from "../features/admin/PostsSlice";
import partnerSlice from "../features/admin/PartnerSlice";
import rolesSlice from "../features/admin/RoleSlice";
import mediasSlice from "../features/admin/MediaSlice";
import categoriesSlice from "../features/admin/CategorySlice";
import productsSlice from "../features/admin/ProductSlice";
import companiesSlice from "../features/admin/CompanySlice";
import ordersSlice from "../features/admin/OrderSlice";
import couponsSlice from "../features/admin/CouponSlice";
import criteriaSlice from "../features/admin/CriteriaSlice";
import registrationSlice from "../features/admin/RegistrationSlice";
import feedbackSlice from "../features/admin/FeedbackSlice";
import pointLogsSlice from "../features/admin/PointLogSlice";
import notificationsSlice from "../features/admin/NotificationSlice";
import sponsorsSlice from "../features/admin/SponsorSlice";
import auditLogsSlice from "../features/admin/AuditLogSlice";
import authSlice from "../features/authSlice";

export const store = configureStore({
  reducer: {
    navigation: navigationReducer,
    carousel: carouselReducer,
    images: carouselReducer,
    news: newsSlice.reducer,
    users: userReducer,
    category: categorySlice,
    youtube: youtubeSlice,
    socialresponsibility: socialresponsibilitySlice,
    newsother: newSliceOtherSlice,
    logo: logoSlice,
    posts: postsSlice,
    partners: partnerSlice,
    roles: rolesSlice,
    medias: mediasSlice,
    categories: categoriesSlice,
    products: productsSlice,
    companies: companiesSlice,
    orders: ordersSlice,
    coupons: couponsSlice,
    criteria: criteriaSlice,
    registrations: registrationSlice,
    feedbacks: feedbackSlice,
    pointLogs: pointLogsSlice,
    notifications: notificationsSlice,
    sponsors: sponsorsSlice,
    auditLogs: auditLogsSlice,
    auth: authSlice,
  },
});


